import { render, staticRenderFns } from "./RiskAcceptedQuotation.vue?vue&type=template&id=a1dafd4e&scoped=true&"
import script from "./RiskAcceptedQuotation.vue?vue&type=script&lang=js&"
export * from "./RiskAcceptedQuotation.vue?vue&type=script&lang=js&"
import style0 from "./RiskAcceptedQuotation.vue?vue&type=style&index=0&id=a1dafd4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dafd4e",
  null
  
)

export default component.exports